const merge = require('lodash/merge');

const typography = {
  font: {
    family: {
      db: '"DeutscheBank-Regular"',
      sansSerif: 'Arial, sans-serif',
      monospace: '"Courier New", monospace',
    },
    size: {
      root: '14px',
      base: '1rem',
      largest: '1.286rem', /* 18px */
      large: '1.143rem', /* 16px || calc(18/14)em */
      small: '0.8571rem', /* 12px || calc(12/14)em */
      dense: '0.7857rem', /* 11px */
    },
  },
  lineHeightBase: '1.5',
  sizing: {
    padding: {
      large: '3.429rem', /* 48px || calc(9/14)em calc(18/14)em */
      medium: '2.286rem', /* 32px || calc(9/14)em 1em */
      small: '1.143rem', /* 16px || calc(6/14)em calc(12/14)em */
      xSmall: '0.5714rem', /* 8px */
    },
    gutter: {
      medium: 'calc(8/14)em',
      small: 'calc(6/14)em',
      large: 'calc(10/14)em',
    },
    border: {
      radius: 'calc(2/14)rem',
    },
  },
};

const computed = {
  font: {
    family: {
      base: `${typography.font.family.db}, ${typography.font.family.sansSerif}`,
    },
  },
};

module.exports = merge(typography, computed);
